<template>
  <div id="Library">

    <Head />
    <div class="library" @click="hidePanel">
      <div class="Main">
        <div class="lTop">
          <span>快速搜索</span>
          <div>
            <div>
              <!-- <div class="getYear">
                <input type="text" placeholder="请选择年份" @click="openYear()" readonly />
                <div id="myPanel" v-show="panelShow"></div>
              </div>-->
              <select v-model="yearValues">
                <option value>请选择年份</option>
                <option v-for="(y, i) in years" :key="i" :value="y.years">{{ y.years }}</option>
              </select>
              <select @change="getvaluemethod($event)" v-model="province">
                <option value>请选择省份</option>
                <option v-for="(item, index) in cityList" :key="index" :value="item.Province">{{ item.Province }}</option>
              </select>
              <select :disabled="unit.length > 0 ? false : true" @change="getunit($event)" v-model="unitValues">
                <option value>请选择单位</option>
                <option v-for="(ma, i) in unit " :key="i" :value="ma.Name">{{ ma.Name }}</option>
              </select>
              <select @change="getMajor1Value($event)" v-model="major1Value">
                <option value>请选择专业大方向</option>
                <option v-for="(item, i) in major1" :key="i" :value="item.Classname">{{ item.Classname }}</option>
              </select>
              <!-- <select
                @change="getMajor2Value($event)"
                :disabled="major2.length>0?false:true"
                v-model="major2Value"
              >-->
              <select :disabled="major2.length > 0 ? false : true" @change="getClassify($event)" v-model="major2Value">
                <option value>请选择专业小方向</option>
                <option v-for="(item, i) in major2" :key="i" :value="item.Classname">{{ item.Classname }}</option>
              </select>
            </div>
            <div>
              <div class="level">
                <select v-model="grade">
                  <option value>请选择成果等级</option>
                  <option value="0">特等</option>
                  <option value="1">一等</option>
                  <option value="2">二等</option>
                  <option value="3">三等</option>
                </select>
              </div>
              <input type="text" placeholder="请输入成果名称" v-model="designation" />
              <span></span>
              <el-button size="medium " style="width:2rem;margin-top:.2rem" type="primary"
                @click="getAchievement(1)">搜索</el-button>
            </div>
          </div>
        </div>
        <div class="search" v-if="total1">为您找到相关结果{{ total1 }}个</div>
        <div class="List" v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
          <!-- <div class="LText">
            "
            <span>2019年,山东</span>"相关
            <span>成果</span>共找到
            <span>456467</span>个结果
          </div>-->
          <ul v-if="achievement.length > 0">
            <li v-for="(item, i) in achievement" :key="i" @click="go(i)">
              <div class="lLText">
                <div class="top">
                  <div class="lTitle">
                    {{ item.Title }}
                    <span class="rank">{{ item.rankName.replace((new RegExp("奖")), "") }}</span>
                  </div>
                  <p>{{ item.year }}年</p>
                </div>
                <div class="bottom">
                  <div>
                    <p>{{ item.ClassParentName }}</p>
                    <p>{{ item.Classname }}</p>
                  </div>
                  <p>{{ item.ProvinceName }}</p>
                </div>
              </div>
            </li>
          </ul>
          <div class="none" v-else>
            <img src="../assets/Index/zanwu.png" alt="">
          </div>
          <div class="hMFoot">
            <!-- <Page /> -->
            <el-pagination style="text-align: right;height: 0.45rem;z-index:1000;" v-if="achievement.length > 0"
              @current-change="CurrentChange1" @size-change="handleSizeChange1" :current-page="Page1"
              :page-size="PageSize1" :page-sizes="[10, 20, 30]" layout="total,sizes, prev, pager, next, jumper"
              :total="total1"></el-pagination>
          </div>
        </div>
      </div>
    </div>
    <RightNav />
    <Foot />
  </div>
</template>
<script>
import Head from "../components/Head";
import Foot from "../components/Foot";
import RightNav from "../components/RightNav";
// import Page from "../components/Page";
export default {
  name: "Library",
  data() {
    return {
      loading: false,
      total1: "",
      // Page1:this.$route.query.page|| 1,
      Page1: 1,
      // PageSize1:this.$route.query.num|| 10,
      PageSize1: 10,
      YearL: [],
      panelShow: false,
      cityList: [],
      province: "", //省份
      provinceID: "", //省份id
      yearValues: "", //年
      unitValues: "", //单位名称
      years: [],
      achievement: [], //页面内容
      unit: [],
      major1: [],
      major2: [],
      major1Value: "", //一级专业
      major2Value: "", //二级专业
      designation: "", //输入框内容,
      company: "",
      ClassifyID: "", //成果id,
      grade: "",
      SuperiorD: "" //查找二级专业用
    };
  },
  inject: ["reload"],
  mounted() {
    this.city(); //获取省份
    this.year(); //获取年份
    this.getAchievement(); //成果全部显示
    this.getMajor1(); //获取一级专业列表
  },

  methods: {
    go(i) {
      this.$router.push("/LibraryDel?id=" + i);
    },
    CurrentChange1(val) {
      console.log(val);
      this.Page1 = val;

      this.getAchievement();
    },
    handleSizeChange1(val) {
      console.log(val);
      this.PageSize1 = val;
      this.getAchievement();
    },
    getMajor1() {
      this.$axios
        .post("classification/index?SuperiorD=0")
        .then(res => {
          console.log(res.data.data.list);
          this.major1 = res.data.data.list;
        });
    },
    getAchievement(i) {
      console.log("dddddeee" + this.provinceID);
      // this.loading=true

      var that = this;
      if (i) {
        this.loading = true;
        this.Page1 = i;
      }

      that.$axios
        .post(
          "reportresult/SelectReportResult?",
          that.$qs.stringify({
            // province: this.$route.query.province || this.provinceID,
            province: this.provinceID,
            // title: this.$route.query.title || this.designation,
            title: this.designation,
            // company: this.$route.query.company || this.company,
            company: this.company,
            // datetime: this.$route.query.datetime || this.yearValues,
            datetime: this.yearValues,
            // ClassifyID: this.$route.query.ClassifyID || this.ClassifyID,
            ClassifyID: this.ClassifyID,
            // rank: this.$route.query.rank || this.grade,
            rank: this.grade,
            status: 0,
            // page: this.$route.query.page || this.Page1,
            page: this.Page1,
            num: this.PageSize1
          })
        )
        .then(res => {
          console.log(res);
          if (res.data.code == 10000) {
            // if (i) {
            //   this.$message({
            //     message: res.data.msg,
            //     type: "success"
            //   });
            // }
            console.log(res);
            this.total1 = res.data.data.total_num;
            this.achievement = res.data.data.list;
            this.loading = false;
          } else {
            this.loading = false;
            console.log(res.data.data);
            this.$message({
              message: res.data.msg,
              type: "warning"
            });
          }
        });
    },

    getClassify: function () {
      console.log(this.major2);
      if (!this.major2Value) {
        this.ClassifyID = "";
        return;
      }
      this.major2.forEach(vlaue => {
        if (this.major2Value == vlaue.Classname) {
          console.log(vlaue.ID);
          this.ClassifyID = vlaue.ID;
        }
      });
    },
    getunit: function () {
      if (!this.unitValues) {
        this.company = "";
        return;
      }
      this.unit.forEach(vlaue => {
        console.log(vlaue.ID);
        if (this.unitValues == vlaue.Name) {
          this.company = vlaue.ID;
        }
      });
    },
    getClassifyID: function () {
      // this.major2.forEach(vlaue=>{
      //   // if(this.major2Value==vlaue.)
      // })
    },
    getMajor1Value: function () {
      let that = this;
      // this.ClassifyID=""

      this.major1.forEach(vlaue => {
        if (vlaue.Classname == this.major1Value) {
          this.$axios
            .post("classification/index?SuperiorD=" + vlaue.ID)
            .then(res => {
              if (res.data.code == 10000) {
                console.log(res.data.data.list);
                that.major2 = res.data.data.list;
              }
            });
        }
      });
    },
    getvaluemethod: function () {
      //获取当前选中的值，并重新赋值
      let that = this;
      that.unit = [];
      if (!this.province) {
        this.provinceID = "";
        this.company = "";
        return;
      }
      this.cityList.forEach(vlaue => {
        if (vlaue.Province == this.province) {
          this.provinceID = vlaue.Code;
          this.$axios
            .post("company/index?province=" + that.provinceID)
            .then(res => {
              // console.log(res.data.data);
              if (res.data.code == 10000) {
                that.unit = res.data.data.list;
              }
              // console.log(this.majors);
            });
        }
      });
    },
    async year() {
      await this.$axios
        .post("reportresult/SelectYear")
        .then(res => {
          console.log(res);
          if (res.data.code == 10000) {
            this.years = res.data.data;
          }
          console.log(this.years);
        });
    },

    async city() {
      await this.$axios.post("province/index").then(res => {
        if (res.data.code == 10000) {
          this.cityList = res.data.data;
        }
        // console.log(this.cityList);
      });
    },
    changeSelect(e) {
      e.target.className = "active";
    },
    openYear() {
      let Y = new Date().getFullYear();
      for (let i = 0; i < 10; i++) {
        this.YearL.push(Y - i);
      }
    },
    hidePanel(event) {
      var sp = document.getElementById("myPanel");

      if (sp) {
        if (!sp.contains(event.target)) {
          //这句是说如果我们点击到了id为myPanel以外的区域

          this.panelShow = false;
        }
      }
    }
  },
  filters: {
    MaxLen(val) {
      if (val.length > 170) {
        val = val.slice(0, 165) + "...";
      }
      return val;
    }
  },
  components: {
    Head,
    Foot,
    RightNav
    // Page
  }
};
</script>
<style lang="less"></style>
<style lang="less" scoped>
#Library {
  width: 100%;
  min-width: 1000px;

  .level {
    margin-top: 0.2rem;
  }

  .library {
    width: 100%;
    padding: 0 1.35rem;
    margin-top: 0.4rem;
    margin-bottom: 1rem;

    .Main {
      width: 100%;
      border: 0.01rem solid #ababab;

      .search {
        color: #999;
        padding: 0.1rem 0 0.1rem 0.2rem;
        font-size: 0.16rem;
        // border-bottom: .01rem solid #ababab;
      }

      .lTop {
        padding: 0.2rem;
        display: flex;
        border-bottom: 0.01rem solid #ababab;

        >span {
          margin-right: 0.5rem;
          color: #797979;
          font-size: 0.2rem;
        }

        >div {
          width: 8.6rem;

          >div {
            display: flex;

            // justify-content: space-between;
            .getYear {
              position: relative;
              border: 0;

              input {
                position: absolute;
                top: 0;
                left: 0;
                cursor: pointer;
              }

              .getYearItem {
                position: absolute;
                width: 2rem;
                height: 1rem;
                background: #fff;
                border: 0.01rem solid #797979;
                border-radius: 0.05rem;
                top: 0.35rem;
                left: 0;
              }
            }

            &:last-child {
              // margin-top: 0.25rem;
              display: flex;
              align-items: flex-end;

              input {
                // display: inline-block;
                width: 49%;
              }

              // span {
              //   width: 1rem;
              //   display: block;
              //   margin-right: 0.2rem;
              // }
            }

            .btn {
              cursor: pointer;
              -moz-user-select: none;
              /*火狐*/
              -webkit-user-select: none;
              /*webkit浏览器*/
              -ms-user-select: none;
              /*IE10*/
              user-select: none;
              width: 2rem;
              height: 0.35rem;
              background: #3f6bc2;
              color: white;
              font-size: 0.16rem;
              display: flex;
              justify-content: center;
              align-items: center;
              border-radius: 0.05rem;
            }
          }
        }

        input,
        select,
        .getYear {
          padding-left: 0.05rem;
          flex-shrink: 0;
          width: 2rem;
          height: 0.35rem;
          border-radius: 0.05rem;
          border: 0.01rem solid #ababab;
          outline: 0;
          margin-right: 0.2rem;
        }
      }

      .List {
        width: 100%;
        position: relative;

        .LText {
          padding: 0.2rem;
          font-size: 0.16rem;
          color: #b2b2b2;

          span {
            color: #fb1818;
          }
        }

        ul {
          width: 100%;
          padding-bottom: 0.8rem;

          li {
            width: 100%;
            padding: 0.4rem 0.3rem;
            border-bottom: 0.01rem solid #ababab;
            display: flex;
            align-items: center;
            justify-content: space-between;
            // height: 1.5rem;
            cursor: pointer;
            position: relative;

            >img {
              width: 2rem;
              height: 100%;
              flex-shrink: 0;
              margin-right: 0.1rem;
            }

            .lLText {
              // position: relative;
              width: 100%;
              // display: flex;
              // flex-direction: column;
              // justify-content: space-between;
              height: 100%;

              .top,
              .bottom {
                display: flex;
                justify-content: space-between;
              }

              .top {
                margin-bottom: 0.1rem;

                p {
                  font-weight: bold;
                }
              }

              .bottom {
                >div {
                  display: flex;

                  p {
                    margin-right: 0.2rem;
                  }
                }
              }

              .lTitle {
                font-size: 0.22rem;
                font-weight: bold;
                margin-bottom: 0.1rem;

                .rank {
                  display: inline-block;
                  font-size: 0.16rem;
                  text-align: center;
                  color: white;
                  width: 1rem;
                  height: 0.3rem;
                  background: #409eff;
                  margin-left: 0.4rem;
                  line-height: 0.3rem;
                  // border-radius: .1rem;
                }
              }

              .lTxt {
                font-size: 0.2rem;
                line-height: 0.35rem;

                span {
                  color: #949494;
                }
              }

              .lDate {
                // position: absolute;
                font-size: 0.18rem;
                display: flex;
                align-items: center;
                // right: 0.2rem;
                // top: 0.1rem;
                margin-bottom: 0.1rem;

                img {
                  width: 0.25rem;
                  height: 0.25rem;
                  border-radius: 50%;
                  margin-right: 0.1rem;
                }

                span {
                  // margin-left: 0.1rem;
                  position: absolute;
                  top: 0.25rem;
                  right: 0.35rem;
                  color: #ababab;
                }
              }
            }
          }
        }

        .none {
          text-align: center;
          padding: 1.5rem 0;
        }

        .hMFoot {
          width: calc(100% - 0.3rem);
          height: 0.5rem;
          position: absolute;
          left: 0.15rem;
          bottom: 0.15rem;
        }
      }
    }
  }
}
</style>